import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sticky top-0 z-40 flex items-center justify-between py-3.5 px-4 bg-primary-color-700" }
const _hoisted_2 = { class: "text-white" }
const _hoisted_3 = { class: "text-white" }
const _hoisted_4 = { class: "flex gap-x-4 items-center" }

import { computed } from "vue"
import { useRouter } from "vue-router"
import GgmsButton from "@/components/GgmsButton.vue"
import MutedMicIcon from "@/components/icons/MutedMicIcon.vue"
import { PhoneIcon, UserIcon, MicrophoneIcon } from "@heroicons/vue/outline"
import { LoginIcon } from "@heroicons/vue/solid"
import { usePhoneCallStore } from "@/stores/phone-call"
import { formatNumberToMinutesAndSeconds, getFullName } from "@/shared/utils/helpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneOnCallBar',
  emits: ["onCloseCall", "onOpenSidebar"],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const phoneCallStore = usePhoneCallStore()

const emit = __emit

const callDuration = computed(() => formatNumberToMinutesAndSeconds(phoneCallStore.callDuration))

const stateTitle = computed(() => {
    const titles = {
        calling: "Calling",
        ongoing: "Connected",
        finished: "Ended",
    }
    return titles[phoneCallStore.phoneCallState]
})

const leadFullName = computed(() =>
    getFullName(phoneCallStore.selectedLead.firstName, phoneCallStore.selectedLead.lastName)
)

function closeCall() {
    emit("onCloseCall")
}

function openSidebar() {
    emit("onOpenSidebar")
}

function toggleMute() {
    phoneCallStore.toggleMute()
}

function openLeadPage() {
    router.push(`/people/${phoneCallStore.currentPhoneCall?.leads?.[0]?._id}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(callDuration.value), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(stateTitle.value) + ": " + _toDisplayString(leadFullName.value), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(UserIcon), {
        class: "h-6 w-6 text-white cursor-pointer",
        onClick: openLeadPage
      }),
      (_unref(phoneCallStore).isMicMuted)
        ? (_openBlock(), _createBlock(MutedMicIcon, {
            key: 0,
            class: "h-6 w-6 text-white stroke-white cursor-pointer",
            onClick: toggleMute
          }))
        : (_openBlock(), _createBlock(_unref(MicrophoneIcon), {
            key: 1,
            class: "h-6 w-6 text-white cursor-pointer",
            onClick: toggleMute
          })),
      _createVNode(_unref(LoginIcon), {
        class: "h-6 w-6 text-white cursor-pointer",
        onClick: openSidebar
      }),
      _createVNode(GgmsButton, {
        iconStart: _unref(PhoneIcon),
        styleType: "danger",
        iconClasses: ['rotate-135 text-white'],
        onClick: closeCall
      }, {
        default: _withCtx(() => [
          _createTextVNode("Hang Up")
        ]),
        _: 1
      }, 8, ["iconStart"])
    ])
  ]))
}
}

})